<div class="flow-timeline-container">
    <div class="flow-timeline" [class.flow-preview]="timelinePreview()">
        <!-- START: Main Block Container -->
        @let containerBlocks = service.getContainerBlocks() | markDoneBlocks: service.currentContainerBlockId;
        @for (block of containerBlocks; track block.id; let index = $index; let isFirstContainer = $first; let isLastContainer = $last) {
            @if (!service.hiddenContainers[block.id]) {
                <div
                    class="block-dot"
                    [class.done]="block.done"
                    [class.active]="block.id === service.currentContainerBlockId"
                    [class.last]="isLastContainer"
                >
                    <div [attr.data-testid]="'block-dot-' + block.id" class="block-dot-title" (click)="service.onContainer(block)">
                        @if (timelinePreview()) {
                            <div class="block-title-index horizontal"></div>
                        } @else {
                            <div class="block-title-index">
                                @if (block.done && !timelinePreview()) {
                                    <mat-icon class="block-done-icon">check</mat-icon>
                                } @else {
                                    {{ index + 1 }}
                                }
                            </div>
                        }
                        @if (block.titleKey | translationKey: block.titleData; as title) {
                            <div class="block-title">{{ title }}</div>
                        }
                    </div>

                    <!-- START: Accordion Block Container -->
                    @if (service.currentAccordionBlockId; as currentAccordionBlockId) {
                        <div class="accordion-dots">
                            @let accordionBlocks = service.getAccordionBlocks(block) | markDoneBlocks: service.currentAccordionBlockId;
                            @for (accordionBlock of accordionBlocks; track accordionBlock.id) {
                                @if (!service.hiddenAccordions[accordionBlock.id]) {
                                    <div
                                        class="accordion-dot"
                                        [class.active]="accordionBlock.id === currentAccordionBlockId"
                                        [class.done]="accordionBlock.done"
                                        [class.virtual-accordion]="accordionBlock.isVirtual"
                                    >
                                        @if (!accordionBlock.isVirtual) {
                                            <div
                                                [attr.data-testid]="'accordion-dot-' + accordionBlock.id"
                                                class="accordion-dot-header"
                                                [class.active]="accordionBlock.id === currentAccordionBlockId"
                                                (click)="service.onAccordion(accordionBlock)"
                                            >
                                                @if (
                                                    accordionBlock.titleKey | translationKey: accordionBlock.titleData;
                                                    as accordionTitle
                                                ) {
                                                    <div class="accordion-title-index" [class.done]="accordionBlock.done"></div>
                                                    <div class="accordion-dot-title">
                                                        {{ accordionTitle }}
                                                    </div>
                                                }
                                            </div>
                                        }
                                    </div>
                                }
                            }
                        </div>
                    }
                    <!-- END: Accordion Block Container -->
                </div>
            }
        }
        <!-- START: Main Block Container -->
    </div>
    @if (timelinePreview()) {
        <button class="flow-expand" (click)="openTimelineOverlay()">
            <mat-icon>expand_more</mat-icon>
        </button>
    }
</div>
